var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72798 4.36365H7.27344L7.63707 9.45456H8.36435L8.72798 4.36365ZM8.00071 11.6364C8.40237 11.6364 8.72798 11.3108 8.72798 10.9091C8.72798 10.5074 8.40237 10.1818 8.00071 10.1818C7.59905 10.1818 7.27344 10.5074 7.27344 10.9091C7.27344 11.3108 7.59905 11.6364 8.00071 11.6364Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipAlert);
export default __webpack_public_path__ + "static/media/tooltip_alert.c404b8a342cc9a73dbcd8d6b44aa7163.svg";
export { ForwardRef as ReactComponent };